<template lang="pug">
  include base.pug
</template>
<script>
import { mapActions } from "vuex";

export default {
	props: ["question", "slug", "helper", "multi_field_num"],
	data() {
		return {
			local_answer: null
		};
	},
	computed: {
		is_error: {
			get() {
				return this.error_message.length !== 0;
			}
		},
		get_state: {
			get() {
				if (
					this.$store.state[this.slug].answer === null ||
					this.$store.state[this.slug].answer === ""
				) {
					return null;
				}
				return !this.is_error;
			}
		},

		error_message: {
			get() {
				if (!this.is_multi_field && this.$store.state[this.slug]) {
					return this.$store.state[this.slug].error_message;
				}
				return "";
			}
		},
		is_required: {
			get() {
				return this.get_question_attribute("is_required", false);
			}
		},
		answer: {
			get() {
				return this.get_question_attribute("answer", null);
			},
			set() {}
		},
		is_displayed: {
			get() {
				let dep = this.dependent_visible;
				if (dep) {
					if (this.multi_field_num) {
						let data = this.$store.state[this.multi_field_parent].answer;
						let i = this.multi_field_num - 1;
						if (!data || !data[i]) {
							return false;
						}

						return (
							this.dependent_visible_values.indexOf(data[i][dep].answer) !== -1
						);
					} else {
						if (this.$store.state[dep]) {
							return (
								this.dependent_visible_values.indexOf(
									this.$store.state[dep].answer
								) !== -1
							);
						} else {
							return false;
						}
					}
				} else {
					return this.get_question_attribute("is_displayed", false);
				}
			}
		},
		dependent_visible: {
			get() {
				return this.$store.state[this.slug].dependent_visible;
			}
		},
		dependent_visible_values: {
			get() {
				return this.$store.state[this.slug].dependent_visible_values;
			}
		},
		dependent_visible_answer: {
			get() {
				let dep = this.dependent_visible;
				if (dep) {
					if (this.multi_field_num) {
						let data = this.$store.state[this.multi_field_parent].answer;
						let i = this.multi_field_num - 1;
						if (!data || !data[i]) {
							return null;
						}
						if (data[i][dep].answer) {
							return data[i][dep].answer;
						}
					}
					if (this.$store.state[dep]) {
						return this.$store.state[dep].answer;
					}
				}

				return null;
			}
		},
		is_multi_field: {
			get() {
				return (
					this.$store.state[this.slug].multi_field_parent &&
					this.$store.state[this.slug].multi_field_parent.length > 0
				);
			}
		},
		multi_field_parent: {
			get() {
				return this.$store.state[this.slug].multi_field_parent;
			}
		},
		answer_externally_updated: {
			get() {
				return this.$store.getters[this.slug + "/answer_externally_updated"];
			}
		}
	},
	methods: {
		...mapActions({
			send_answer: "question/send_answer"
		}),
		delayed_send_answer(slug) {
			let v = this;
			this.$nextTick(function() {
				v.$store.dispatch("question/send_answer", slug);
			});
		},
		process_change() {
			let v = this;
			this.$nextTick(function() {
				if (v.is_multi_field) {
					let payload = {
						parent_slug: v.multi_field_parent,
						q_slug: v.slug,
						item_num: v.multi_field_num,
						answer: this.local_answer
					};
					v.$store.dispatch(
						v.multi_field_parent + "/process_field_change",
						payload,
						{
							root: true
						}
					);
				} else {
					v.$store.commit(v.slug + "/set_answer", v.local_answer);
					v.send_answer(v.slug);
				}
			});
		},
		get_question_attribute(attribute, default_value) {
			if (this.multi_field_num) {
				let data = this.$store.state[this.multi_field_parent].answer;
				let i = this.multi_field_num - 1;
				if (!data || !data[i]) {
					return default_value;
				}
				if (data[i][this.slug][attribute]) {
					return data[i][this.slug][attribute];
				}
			} else {
				if (this.$store.state[this.slug]) {
					return this.$store.state[this.slug][attribute];
				}
			}
			return default_value;
		}
	},
	mounted() {
		if (this.dependent_visible) {
			this.$watch("dependent_visible_answer", function(new_answer, old_answer) {
				if (
					old_answer !== null &&
					this.local_answer !== null &&
					this.local_answer !== ""
				) {
					this.local_answer = "";
					this.answer = "";

					this.process_change();
				}
			});
		}

		this.local_answer = this.answer;

		if (this.answer_externally_updated) {
			this.$watch("answer", function(new_answer) {
				this.local_answer = new_answer;
			});
		}
	}
};
</script>

<style>
.requiredField {
	color: #a20000;
	font-size: 2em;
}
</style>
